import { useQuery } from "@tanstack/react-query"
import { trpcClient } from "@tokenterminal/core/utils/trpc"
import { type Interval } from "@tokenterminal/tt-analytics-api-types/dist/api/zoom"

export const useTimeseries = ({
  dataIds,
  metricIds,
  interval,
  groupBy,
  marketSectorIds,
  enabled = true,
}: {
  dataIds: string[]
  metricIds: string[]
  interval: Interval
  groupBy: "chain" | "market-sector" | "projects" | "project+chain"
  marketSectorIds?: string[]
  enabled?: boolean
}) => {
  const fixedInterval =
    interval === "max" || interval === "ytd" ? "365d" : interval

  return useQuery({
    queryKey: [
      "timeseries",
      dataIds,
      metricIds,
      fixedInterval,
      groupBy,
      marketSectorIds,
    ],
    queryFn: async () => {
      const { data, sorted_data_ids } =
        await trpcClient.metrics.postTimeseries.mutate({
          data_ids: dataIds,
          metric_ids: metricIds,
          groupBy: groupBy,
          interval: fixedInterval,
          market_sector_ids: marketSectorIds,
        })

      return { data, sorted_data_ids }
    },
    enabled,
  })
}
